import axios from "axios";
import i18n from "i18next";

import { SET_CUSTOMER, SET_CUSTOMERS } from "./types";
import { checkIsExternalUser } from "../helpers/Authorization/authorizationHelpers";
import { createAsyncAction } from "./appActions";
import { getApiUrl } from "../helpers/apiUrlHelpers";

export const getCustomer = createAsyncAction(
  resolve => customerId =>
    resolve(async dispatch => {
      const lang = localStorage.getItem("language");
      const response = checkIsExternalUser()
        ? { data: { customerName: i18n.t("purchaseOrder.myOrders") } }
        : await axios.get(`${getApiUrl()}/customer/${customerId}`, { params: { lang } });

      dispatch({ type: SET_CUSTOMER, payload: response.data });
    }),
  dispatch => dispatch({ type: SET_CUSTOMERS, payload: {} })
);

export const getCustomers = createAsyncAction(
  resolve => () =>
    resolve(async dispatch => {
      const lang = localStorage.getItem("language");
      const response = checkIsExternalUser() ? { data: {} } : await axios.get(`${getApiUrl()}/customer`, { params: { lang } });
      dispatch({ type: SET_CUSTOMERS, payload: response.data });
    }),
  dispatch => dispatch({ type: SET_CUSTOMERS, payload: {} })
);



// WEBPACK FOOTER //
// ./src/actions/customerActions.js